import { IController } from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';
import { UtilitiesService } from 'src/ng2/shared/services/utilities/utilities.service';

export class DateTimeStepCtrl implements IController {
  static $inject = ['$scope', '$mdDialog', 'ImSchool', 'UtilitiesService'];

  // Bindings
  private currentSupport;
  private currentSchool;
  private startDate;
  private endDate;
  private supportRepeats;
  private times;

  minDate;
  endOfTermDate;

  initEndOfTermISO;
  initStartDate;
  initEndDate;

  constructor(
    private $scope,
    private $mdDialog,
    private imSchool: ImSchool,
    private UtilitiesService: UtilitiesService,
  ) {}

  $onInit() {
    // SHARED FUNCTIONALITY
    this.$scope.initialRepeatValues = angular.copy(this.currentSupport.schedule); // copy data on step initialization
    // $scope.updatedRepeatValues; // store copy of updated model on 'done'
    this.$scope.hasBeenUpdatedBool = false;

    this.$scope.countWeeksOfMonth = function(dateObj) {
      let year = dateObj.getFullYear();
      let month_number = dateObj.getMonth();
      let firstOfMonth = new Date(year, month_number - 1, 1);
      let lastOfMonth = new Date(year, month_number, 0);
      let used = firstOfMonth.getDay() + lastOfMonth.getDate();

      return Math.ceil(used / 7);
    };

    this.$scope.getWeekOfMonth = function(isoString) {
      // get week # of month based on date
      let converted = moment(isoString.replace(/T.+/, '')).format('MM-DD-YYYY');
      let d = new Date(converted);
      let date = d.getDate();
      let day = d.getDay();
      let weekOfMonth = Math.ceil((date - 1 - day) / 7);

      return weekOfMonth + 1;
    };

    this.$scope.ordinal_suffix_of = function(i) {
      // create ordinal suffix for getWeekOfMonth
      let j = i % 10;
      let k = i % 100;
      if (j === 1 && k !== 11) {
        return i + 'st';
      } else if (j === 2 && k !== 12) {
        return i + 'nd';
      } else if (j === 3 && k !== 13) {
        return i + 'rd';
      } else {
        return i + 'th';
      }
    };

    this.$scope.constructMonthlySummary = isoString => {
      // construct summary for monthly interval
      let daysArray = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      let formattedIso = moment(isoString.replace(/T.+/, '')).format('MM-DD-YYYY');
      let convertedIso = new Date(formattedIso);
      let month = convertedIso.getUTCMonth() + 1; // add 1
      let date = convertedIso.getUTCDate();
      let day = convertedIso.getDay();
      let year = convertedIso.getUTCFullYear();
      let weeksInMonth = this.$scope.countWeeksOfMonth(new Date(year, month, date));
      let weekOfMonth = this.$scope.getWeekOfMonth(isoString);

      if (weeksInMonth === weekOfMonth || weekOfMonth === 6) {
        return 'last ' + daysArray[day] + ' of the month';
      } else if (weekOfMonth === 1) {
        return 'first ' + daysArray[day] + ' of the month';
      } else {
        return this.$scope.ordinal_suffix_of(weekOfMonth) + ' ' + daysArray[day] + ' of the month';
      }
    };

    this.$scope.appendFrequencyTag = function(interval) {
      // append proper tag to frequency
      if (interval === 'DAILY') {
        return 'days';
      } else if (interval === 'WEEKLY') {
        return 'weeks';
      } else if (interval === 'MONTHLY') {
        return 'months';
      } else {
        return;
      }
    };

    // convert boolean values from repeatsOn obj to humanName for summary
    this.$scope.getRepeatDays = function(daysObj) {
      let repeatDaysArray = [];
      _.forOwn(daysObj, function(value, key) {
        if (value === true) {
          repeatDaysArray.push(_.capitalize(key));
        }
      });
      return repeatDaysArray.join(', ');
    };

    this.$scope.constructSummary = (interval, frequency, daysObj, daysFn) => {
      // build summary
      let date = new Date(this.currentSupport.schedule.startsOn);
      let day = date.getUTCDate();

      if (interval === 'DAILY') {
        return frequency < 1 ? 'Daily' : 'Every ' + frequency + ' days';
        // MONTHLY
      } else if (interval === 'MONTHLY') {
        if (this.currentSupport.schedule.repeatsBy === 'DAY_OF_MONTH') {
          return frequency > 1 ? 'Every ' + frequency + ' months on day ' + day : 'Monthly on day ' + day;
        } else if (this.currentSupport.schedule.repeatsBy === 'DAY_OF_WEEK') {
          return frequency > 1
            ? 'Every ' +
                frequency +
                ' months on the ' +
                this.$scope.constructMonthlySummary(this.currentSupport.schedule.startsOn)
            : 'Monthly on the ' + this.$scope.constructMonthlySummary(this.currentSupport.schedule.startsOn);
        }
      } else if (interval === 'WEEKLY') {
        return frequency > 1
          ? 'Every ' + frequency + ' weeks ' + 'on ' + daysFn(daysObj)
          : 'Weekly on ' + daysFn(daysObj);
      } else if (interval === 'NONE') {
        return;
      } else {
        return 'WEEKLY';
      }
    };

    const currentDate = this.UtilitiesService.dateToUTCWithoutTime(new Date());
    const endOfTermISO = this.imSchool.getEndDateForCurrentTerm(this.currentSchool);
    const endOfTermDate = this.UtilitiesService.dateToUTCWithoutTime(new Date(endOfTermISO));

    // replace -
    const pattern1 = /-/g;
    const replacement1 = '/';

    // remove T.+
    const pattern2 = /T.+/;
    const replacement2 = '';

    this.startDate = this.currentSupport.schedule.startsOn
      ? new Date(this.currentSupport.schedule.startsOn.replace(pattern1, replacement1).replace(pattern2, replacement2))
      : currentDate;

    this.endDate = this.currentSupport.schedule.endsOn
      ? new Date(this.currentSupport.schedule.endsOn.replace(pattern1, replacement1).replace(pattern2, replacement2))
      : endOfTermDate;

    this.minDate = this.startDate;

    this.endOfTermDate = endOfTermDate;

    this.supportRepeats = { status: null }; // checkbox model
    this.supportRepeats.status = this.$scope.initialRepeatValues.repeats !== 'NONE' ? true : false; // manage starting state of date/time stepper

    this.times = [
      '6:00am',
      '6:30am',
      '7:00am',
      '7:30am',
      '8:00am',
      '8:30am',
      '9:00am',
      '9:30am',
      '10:00am',
      '10:30am',
      '11:00am',
      '11:30am',
      '12:00pm',
      '12:30pm',
      '1:00pm',
      '1:30pm',
      '2:00pm',
      '2:30pm',
      '3:00pm',
      '3:30pm',
      '4:00pm',
      '4:30pm',
      '5:00pm',
      '5:30pm',
      '6:00pm',
      '6:30pm',
      '7:00pm',
      '7:30pm',
      '8:00pm',
      '8:30pm',
      '9:00pm',
      '9:30pm',
      '10:00pm',
    ];

    // ng-init use
    this.initEndOfTermISO = endOfTermISO;
    this.initStartDate = this.startDate.toISOString();
    this.initEndDate = this.endDate.toISOString();
  }

  // Functions
  updateDateAttributes() {
    this.minDate = this.startDate;
    this.currentSupport.schedule.startsOn = this.startDate.toISOString();
    this.currentSupport.schedule.endsOn = this.endDate.toISOString();
  }

  clearRepeatDetails = () => {
    // set model to 'NONE', 0, false
    this.currentSupport.schedule.repeats = 'NONE';
    this.currentSupport.schedule.repeatsBy = 'NONE';
    this.currentSupport.schedule.repeatsEvery = 1;
    this.currentSupport.schedule.repeatsOn = _.mapValues(this.currentSupport.schedule.repeatsOn, function() {
      return false;
    });
  };

  returnRepeatDetailsToLastUpdate = () => {
    // set schedule to last update made on 'done' in scheduleDialog
    this.currentSupport.schedule = angular.copy(this.$scope.updatedRepeatValues);
  };

  setRepeatDetails = supportRepeatsBool => {
    // set currentSupport.schedule based on repeat checkbox: fires on-change (checkbox)
    if (
      supportRepeatsBool &&
      !_.size(this.$scope.updatedRepeatValues) &&
      this.$scope.initialRepeatValues.repeats === 'NONE'
    ) {
      this.showRepeatDialog();
    } else if (supportRepeatsBool && !_.size(this.$scope.updatedRepeatValues)) {
      this.currentSupport.schedule = angular.copy(this.$scope.initialRepeatValues);
    } else if (!supportRepeatsBool) {
      this.clearRepeatDetails();
    } else if (supportRepeatsBool && _.size(this.$scope.updatedRepeatValues)) {
      this.returnRepeatDetailsToLastUpdate();
    }
  };

  showRepeatDialog = (ev?) => {
    this.$scope.currentSupport = this.currentSupport;
    this.$mdDialog.show({
      scope: this.$scope,
      preserveScope: true,
      disableParentScroll: true,
      template: require('./schedule-dialog.html'),
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose: false,
      controller: 'scheduleDialogCtrl',
      controllerAs: 'scheduleDialogCtrl',
    });
  };

  validateDateTimeStep = support => {
    const datesAreValid = moment(support.schedule.endsOn).isAfter(moment(support.schedule.startsOn));
    return support.schedule.startsOn && support.schedule.startTime && support.schedule.endTime && datesAreValid
      ? false
      : true;
  };

  persistDateField($event) {
    $event.preventDefault();
    return false;
  }
}

angular.module('nv.SupportsModule').controller('dateTimeStepCtrl', DateTimeStepCtrl);
